export enum CareNavigationStepper {
    Wrapper = 'CareNavigationStepper.Wrapper',
}

export enum CareNavigationContactMethodStepTestId {
    RadioGroup = 'CareNavigationContactMethodStepTestId.RadioGroup',
}

export enum CareNavigationGoalsStepTestId {
    DetailsField = 'CareNavigationGoalsStepTestId.DetailsField',
}

export enum CareNavigationContactInformationStepTestId {
    ContactPreferenceInput = 'CareNavigationContactInformationStepTestId.ContactPreferenceInput',
    SaveSettingsCheckbox = 'CareNavigationContactInformationStepTestId.SaveSettingsCheckbox',
    PhoneEditLink = 'CareNavigationContactInformationStepTestId.PhoneEditLink',
    EmailEditLink = 'CareNavigationContactInformationStepTestId.EmailEditLink',
    UserContactPreference = 'CareNavigationContactInformationStepTestId.UserContactPreference',
}

export enum CareNavigationAllSetStepTestId {
    FinishButton = 'CareNavigationAllSetStepTestId.FinishButton',
}

export enum ButtonGroupTestID {
    FirstButton = 'ButtonGroupTestID.FirstButton',
    SecondButton = 'ButtonGroupTestID.SecondButton',
}
